<div *ngIf="show">
    <strong >{{type}}</strong>
    <div class="progress-bar-container block">
        <mat-progress-bar mode="determinate" [value]="totalAllocation" [ngClass]="{'disabled': !isEditable}"></mat-progress-bar>
        <p class="percentage" style="line-height:1.5rem">{{ totalAllocation }}%</p>
        <small class="error-message" *ngIf="totalAllocation !== 100">(Needs to be 100%)</small>
    </div>
</div>